$('#id_search').change(function () {
  let search = `search[${$(this).val()}]`
  $('#id_numeric').attr('name', search)
})

$('.activate-help-contact').click(function (e) {
  e.preventDefault()
  if (window.Intercom) {
    Intercom('show')
  } else {
    // Fallback to email if Intercom is not available
    console.warn('Intercom chat widget not available, falling back to email')
    window.location.href = 'mailto:support@fishisfast.com'
  }
})
